import React, { useEffect, useRef } from 'react';
import moduleStyles from './ai-block-preview.module.scss';
import { useSelector } from 'react-redux';
import { generateAiEffectBlocksXmlFromResult } from './utils';
/**
 * Previews the blocks generated by the AI block in Dance Party.
 */
var AiBlockPreview = function (_a) {
    var results = _a.results;
    var blockPreviewContainerRef = useRef(null);
    var workspaceRef = useRef(null);
    var isRtl = useSelector(function (state) { return state.isRtl; });
    // Create the workspace once the container has been rendered.
    useEffect(function () {
        if (!blockPreviewContainerRef.current) {
            return;
        }
        var xml = generateAiEffectBlocksXmlFromResult(results);
        var blocks = Blockly.utils.xml.textToDom(xml);
        workspaceRef.current = Blockly.BlockSpace.createReadOnlyBlockSpace(blockPreviewContainerRef.current, blocks, { rtl: isRtl });
        return function () {
            var _a;
            (_a = workspaceRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        };
    }, [blockPreviewContainerRef, isRtl, results]);
    // Dispose of the workspace on unmount.
    useEffect(function () { return function () { var _a; return (_a = workspaceRef.current) === null || _a === void 0 ? void 0 : _a.dispose(); }; }, []);
    return (React.createElement("span", { ref: blockPreviewContainerRef, className: moduleStyles.container }));
};
export default AiBlockPreview;
